import { backdropAtom } from "@/lib/atoms";
import { useAtom } from "jotai";

const useBackdrop = () => {
  const [backdrop, setBackdrop] = useAtom(backdropAtom);
  return { backdrop, setBackdrop };
};

export default useBackdrop;
